import { UserGroups } from './user-groups.enum';

export interface User {
   uid: string;
   firstname: string;
   lastname: string;
   groups: UserGroups[];
   sub: string;
   mail: string;
   ravagoCustomerCountryIsoCode: string;
   ravagoCustomerId: number;
}

export const pageBuilderUser: User = {
   uid: '123',
   firstname: 'Bob',
   lastname: 'the Builder',
   groups: [UserGroups.ravagoSalesRepresentative, UserGroups.customerPortal],
   sub: 'sub',
   mail: 'mail@ravago.be',
   ravagoCustomerCountryIsoCode: 'BE',
   ravagoCustomerId: 1
};
